import { PublicOrderTrackingStop } from "../../../api/publicTracking";

export default function OrderTrackingStops({
  stops,
}: {
  stops: PublicOrderTrackingStop[];
}) {
  return (
    <ol aria-label="Stopp på ordren" className="space-y-5">
      {stops.map((stop, index) => {
        const type =
          stop.type === "PICKUP"
            ? "Henting"
            : stop.type === "DELIVERY"
              ? "Levering"
              : "Stopp";
        const status =
          stop.status === "COMPLETED"
            ? stop.type === "PICKUP"
              ? "Hentet"
              : stop.type === "DELIVERY"
                ? "Levert"
                : "Fullført"
            : stop.status === "IN_PROGRESS"
              ? "Pågår"
              : stop.status === "CANCELLED"
                ? "Kansellert"
                : "Ikke utført";
        const address = [
          stop.address?.addressLine,
          [stop.address?.postCode, stop.address?.city]
            .filter(Boolean)
            .join(" "),
        ]
          .filter(Boolean)
          .join(", ");
        const completed = stop.completedAt ? new Date(stop.completedAt) : null;
        return (
          <li
            key={`${stop.stopNumber ?? index}-${stop.type}`}
            className="border-b border-[#ebe6ef] pb-5 last:border-0 last:pb-0"
          >
            <div className="flex flex-wrap items-center justify-between gap-2">
              <h3 className="font-bold">
                {index + 1}. {type}
              </h3>
              <span className="text-sm font-medium">{status}</span>
            </div>
            <p className="mt-1 break-words text-sm">
              {address || "Adresse ikke oppgitt"}
            </p>
            {stop.plannedDate && (
              <p className="mt-1 text-sm text-[#706879]">
                Planlagt dato: {stop.plannedDate}
              </p>
            )}
            {completed && !Number.isNaN(completed.getTime()) && (
              <p className="mt-1 text-sm text-[#706879]">
                Fullført:{" "}
                {new Intl.DateTimeFormat("nb-NO", {
                  dateStyle: "medium",
                  timeStyle: "short",
                  timeZone: "Europe/Oslo",
                }).format(completed)}
              </p>
            )}
          </li>
        );
      })}
    </ol>
  );
}
